<template>
    <datepicker ref="calendarDropDown"
                v-model="date"
                :placeholder="placeholder"
                :language="languages[language]"
                :disabled-dates="disabledDates"
                :clear-button="clearButton"
                v-click-outside="closeCalendar"
                format="dd-MM-yyyy">
    </datepicker>
</template>

<script>
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import * as lang from "vuejs-datepicker/src/locale";
    import startOfDay from 'date-fns/startOfDay';
    import endOfDay from 'date-fns/endOfDay';

    export default {
        name: "CustomDatepicker",
        components: {Datepicker},
        props: {
            placeholder: {
                type: String,
                default: ''
            },
            value: {
                type: Number
            },
            isDisabledDates: {
                type: Boolean,
                default: true
            },
            clearButton: {
                type: Boolean,
                default: false
            },
            isFilterTo: {
                type: Boolean,
                default: false
            }
        },
        created() {
            if (!this.isDisabledDates) {
                this.disabledDates = {};
            }
        },
        data() {
            return {
                language: "vi",
                languages: lang,
                disabledDates: {
                    to: this.getYesterday()
                }
            }
        },
        methods: {
            openCalendar() {
                if (!this.$refs.calendarDropDown.isOpen) {
                    this.$refs.calendarDropDown.showCalendar();
                }
            },
            closeCalendar() {
                if (this.$refs.calendarDropDown.isOpen) {
                    this.$refs.calendarDropDown.close(true);
                }
            },
            getYesterday() {
                const dateObj = new Date();
                dateObj.setDate(dateObj.getDate() - 1);
                return dateObj;
            }
        },
        computed: {
            date: {
                get() {
                    return this.value;
                },
                set(val) {
                    if (val) {
                        const dayCurrent = (new Date()).getDay();
                        const daySelect = val.getDay();
                        let mls = val.valueOf();
                        if (dayCurrent < daySelect) {
                            mls = startOfDay(val).valueOf();
                        }
                        if (this.isFilterTo) {
                            mls = endOfDay(val).valueOf();
                        }
                        this.$emit('input', mls);
                    } else {
                        this.$emit('input', val);
                    }
                }
            }
        }
    }
</script>

<style>

    .vdp-datepicker input {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin: 0;
        font-variant: tabular-nums;
        list-style: none;
        -webkit-font-feature-settings: 'tnum';
        font-feature-settings: 'tnum';
        position: relative;
        display: inline-block;
        width: 100%;
        height: 48px;
        padding: 4px 11px 4px 58px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 20px;
        line-height: 1.5;
        background-color: #fff;
        background-image: none;
        /*border: 1px solid #d9d9d9;*/
        border-radius: 4px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }

    .vdp-datepicker__clear-button {
        position: absolute;
        top: 23%;
        right: 12px;
    }
</style>
